export const EMPLOYEE_DETAILS_OPEN_SLIDEOUT = 'EMPLOYEE_DETAILS_OPEN_SLIDEOUT';
export const EMPLOYEE_DETAILS_CLOSE_SLIDEOUT = 'EMPLOYEE_DETAILS_CLOSE_SLIDEOUT';
export const EMPLOYEE_DETAILS_UPDATE_EMPLOYEES = 'EMPLOYEE_DETAILS_UPDATE_EMPLOYEES';
export const EMPLOYEE_DETAILS_START_UPDATE_REQUEST = 'EMPLOYEE_DETAILS_START_UPDATE_REQUEST';
export const EMPLOYEE_DETAILS_SEND_UPDATE_REQUEST = 'EMPLOYEE_DETAILS_SEND_UPDATE_REQUEST';
export const EMPLOYEE_DETAILS_SEND_UPDATE_SUCCESS = 'EMPLOYEE_DETAILS_SEND_UPDATE_SUCCESS';
export const EMPLOYEE_DETAILS_SEND_UPDATE_FAILURE = 'EMPLOYEE_DETAILS_SEND_UPDATE_FAILURE';

// Employee Search Action Types
export const EMPLOYEE_SEARCH_REQUEST = 'EMPLOYEE_SEARCH_REQUEST';
export const EMPLOYEE_SEARCH_SUCCESS = 'EMPLOYEE_SEARCH_SUCCESS';
export const EMPLOYEE_SEARCH_FAILURE = 'EMPLOYEE_SEARCH_FAILURE';
